import DB from 'offline/db'
import Util from 'offline/util'

// Port of api/fuel/app/classes/filter/package/games/game/data/listing.php
export default {
	run: function(filter, data, config, global) {
		global.listComments = {}
		if (!filter.source || (!filter.source.list && !filter.source['list.sorted'])) return
		if (!global.gameIds || !global.gameIds.length) return

		var editionId = filter.source.list || filter.source['list.sorted']
		var rows = DB.query(
			'SELECT game_id, list_comment_text FROM list_comment WHERE list_edition_id = ? AND game_id IN(' + Util.in(global.gameIds) + ')',
			[editionId]
		)

		for (var i = 0; i < rows.length; i++) {
			global.listComments[rows[i].game_id] = rows[i].list_comment_text || ''
		}
	}
}
